import { cn } from '@crestrewards/ui';

/**
 * Standard page frame: title block on the left, page-level actions on the
 * right, content below. Every routed page renders inside one of these so
 * spacing and heading levels stay consistent across the console.
 */
export default function PageContainer({
  title,
  description,
  actions,
  className,
  children,
}) {
  return (
    <div className="mx-auto w-full max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="truncate text-lg font-semibold tracking-tight text-foreground">
            {title}
          </h1>
          {description ? (
            <p className="mt-1 max-w-2xl text-meta text-muted-foreground">{description}</p>
          ) : null}
        </div>

        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>

      <div className={cn('space-y-6', className)}>{children}</div>
    </div>
  );
}
